import React from "react";
import track from "react-tracking";

import { Box } from "@metrea-ui/v2";
import { PageHeader } from "../components/SiteLayout/Header";
import { PageFooter } from "../components/SiteLayout/Footer";

const Home_Page = () => {
	return (
		<>
			<PageHeader pageTitle="Homepage" />
			<Box className="pageContent">
				<h4>More to come...</h4>
				<PageFooter />
			</Box>
		</>
	);
};

export const Home = track(
	{ page: "Home" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) }
)(Home_Page);
